// extracted by mini-css-extract-plugin
export var mainTitle = "style-mod--main-title--e5cf8";
export var serviceContainer = "style-mod--service-container--1568b";
export var serviceDesc = "style-mod--service-desc--7bca9";
export var serviceImage = "style-mod--service-image--6bc1c";
export var serviceSingleBox = "style-mod--service-single-box--2fa1f";
export var serviceTitle = "style-mod--service-title--33168";
export var threeRows = "style-mod--three-rows--4fc54";